<hr>
<div>
    <p *ngIf="isBulkScore === true">Your scores will be made available to this institution through their online portal as soon as your scores are posted. For this reason, we will not physically mail an Official Score Report to them.</p>
    <div *ngIf="isBulkScore === false">
        <div
            class="col-md-12"
            *ngIf="priorityShippingOption !== null && !(institution.isRegularMail || institution.expressShipping)"
        >
            <div class="form-group surveyQuestion">
                <div class="radio">
                    <label class="choice">
                        <input
                            type="radio"
                            name="{{institution.scoreRecipient.id}}"
                            [(ngModel)]="selectedOption"
                            (change)="shipmentPreferenceUpdated()"
                            [value]="noMailOption"
                        >
                        <span style="white-space: pre-wrap;">
                            {{noMailOption.shortDescription}}
                        </span>
                    </label>
                    <label class="choice">
                        <input
                            type="radio"
                            name="{{institution.scoreRecipient.id}}"
                            [(ngModel)]="selectedOption"
                            (change)="shipmentPreferenceUpdated()"
                            [value]="regularMailOption"
                        >
                        <span style="white-space: pre-wrap;">
                            {{regularMailOption?.shortDescription}}<span> ({{regularMailOption.description}})</span>
                            <span> - Free</span>
                        </span>
                    </label>
                    <label class="choice">
                        <input
                            type="radio"
                            name="{{institution.scoreRecipient.id}}"
                            [(ngModel)]="selectedOption"
                            (change)="shipmentPreferenceUpdated()"
                            [value]="priorityShippingOption"
                        >
                        <span style="white-space: pre-wrap;">
                            {{priorityShippingOption?.shortDescription}}<span> ({{priorityShippingOption?.description}})</span>
                            <span> - CAD {{priorityShippingOption?.price}}</span>
                        </span>
                    </label>
                </div>
            </div>
        </div>
        <small
            class="highlight"
            *ngIf="(institution.isRegularMail || isOldScoreReportOrder) && !institution.expressShipping"
        >You have ordered a regular mail for this institution.</small>
        <br />
        <small
            class="highlight"
            *ngIf="institution.expressShipping"
        >You have ordered a priority shipping for this institution.</small>
    </div>
</div>
